import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationResult, PublicClientApplication } from '@azure/msal-browser';
import { MsalAuthService } from 'src/app/service/msal-auth.service';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GatewayConnectorsService } from '../service/gateway-connectors.service';

@Component({
  selector: 'app-auth-callback',
  template: '<p>Processando login...</p>',
})
export class AuthCallbackComponent implements OnInit {
  private msalInstance: PublicClientApplication | null = null;

  constructor(
    private msalAuthService: MsalAuthService, 
    private router: Router, 
    private gatewayConnectorsService: GatewayConnectorsService,
    private http: HttpClient) {}

  ngOnInit() {
    const hash = window.location.hash;

    if (hash.includes('code=')) {
      this.handleResponde(hash);
    } else {
      this.startLogin();
    }
  }

  private configureMsalInstance(clientId: string, authority: string) {
    this.msalInstance = new PublicClientApplication({
      auth: {
        clientId: clientId,
        authority: authority,
        redirectUri: `${environment.siteUrl}/azure-auth-callback`,
      },
      cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: true,
      },
    });
    this.msalAuthService.setMsalInstance(this.msalInstance);
  }

  private async startLogin() {
    const clientId = this.msalAuthService.getClientId();
    const tenantId = this.msalAuthService.getTenantId();
    if (clientId && tenantId) {
      const authority = `https://login.microsoftonline.com/${tenantId}`;
      this.configureMsalInstance(clientId, authority);

      try {
        await this.msalInstance.handleRedirectPromise();
      } catch (error) {
        console.error("Erro ao processar o redirecionamento: ", error);
      }

      this.msalInstance?.loginRedirect({
        scopes: ['openid', 'profile', 'https://graph.microsoft.com/Sites.Read.All'],
        state: JSON.stringify({
          clientId: clientId,
          tenantId: tenantId,
          scope: this.msalAuthService.getScope(),
          authority: authority,
          redirectUrl: this.msalAuthService.getCurrentRoute(),
        })
      });
    } else {
      console.error('clientId ou authority ausentes para iniciar o login.');
      this.router.navigate(['/']);
    }
  }

  private async handleResponde(hash: string) {
    const params = new URLSearchParams(hash.replace('#', '?'));
    const code = params.get('code');
    const state = params.get('state');
     
    if (state) {
      const encodedJson = state.split('|').pop();
      if (encodedJson) {
        const decodedJson = decodeURIComponent(encodedJson);
        const stateObject = JSON.parse(decodedJson);
        const redirectUrl = stateObject.redirectUrl;

        const msalParams = sessionStorage.getItem(`msal.${stateObject.clientId}.request.params`);
        const paramsObject = JSON.parse(atob(msalParams));

        this.msalAuthService.setAuthCode(code);
        this.msalAuthService.setCodeVerifier(paramsObject["codeVerifier"]);
        this.msalAuthService.setClientId(stateObject.clientId);
        this.msalAuthService.setTenantId(stateObject.tenantId);
        this.msalAuthService.setScope(stateObject.scope);

        const accessToken = await this.exchangeAuthorizationCodeForToken();

        this.msalAuthService.setAccessToken(accessToken);

        this.router.navigateByUrl(redirectUrl || '/');
      }
    }
  }

  private async exchangeAuthorizationCodeForToken() {
    const tokenResponse = await this.gatewayConnectorsService
      .authenticateAzure(
        this.msalAuthService.getAuthCode(), 
        this.msalAuthService.getCodeVerifier(),
        this.msalAuthService.getScope(),
        `${environment.siteUrl}/azure-auth-callback`
      )
      .toPromise();

    return tokenResponse["accessToken"];
  }
}